import * as React from "react";
import {
  ICheckboxesElement,
  IRadioButtonsElement,
  InputElementUnion,
  ISelectElement,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";
import { SelectableOptionsEditor } from "./options-editor";

export type OnSelectableElementUpdate = (element: InputElementUnion) => void;

type SelectableEditorProps = {
  element: ICheckboxesElement | ISelectElement | IRadioButtonsElement;
  onElementUpdate: OnSelectableElementUpdate;
  hideValidation?: boolean;
};

export const SelectableEditor: React.FC<SelectableEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <SelectableOptionsEditor element={element} />
      {element.inputType === "checkboxes" && (
        <>
          <div className="field">
            <label className="label">最小チェック数</label>
            <div className="control">
              <p>{element.minItems}</p>
            </div>
          </div>
          <div className="field">
            <label className="label">最大チェック数</label>
            <div className="control">
              <p>{element.maxItems}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
